import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-select-bar-two',
  templateUrl: './select-bar-two.component.html',
  styleUrls: ['./select-bar-two.component.css']
})
export class SelectBarTwoComponent implements OnInit {
  @Input() type;
  @Input() dataArr;
  @Output() changeAction = new EventEmitter();
  selectType: boolean;

  constructor() { }

  ngOnInit() {
    this.checkType();

  }
  changeEvent(evt) {
    this.changeAction.emit(evt.target.value);
  }

  checkType() {
    this.selectType = this.type == '2' ? false : true;

  }

}
